export const BillingFormFieldTypes = {
  AGENCY: 'agencyId',
  CLIENT: 'clientId',
  BRAND: 'brandId',
  BILLING_CONTACT: 'billingContactId',
  PURCHASE_ORDER: 'purchaseOrder',
  AUTHORIZED_BUDGET: 'authorizedBudget',
} as const;
